/**
 * Цвет
 */
enum TirPmButtonVariantEnum {
  /**
   * Основное действие
   * */
  AccentState = "accent",
  /**
   * Обычная кнопка действия
   */
  PrimaryState = "primary",
  /**
   * Второстепенное
   */
  SecondaryState = "secondary",
  /**
   * Третье состояние
   */
  TertiaryState = "tertiary",
  /**
   * Ссылка
   */
  LinkState = "link",
  /**
   * Ссылка
   */
  LinkInvertState = "link-invert",
}
/**
 * Экспорт
 */
export default TirPmButtonVariantEnum;
